import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';
import { FormGroup } from 'reactstrap';
import { Field } from 'redux-form';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import {
  ITINERARY_COUNTER_REPORT_PATH,
  NEW_ITINERARY_COUNTER_REPORT_PATH,
} from '../../../../config/paths';
import { postItineraryCounterReport } from '../../../../actions';
import Content from '../../../layout/Content';
import FormItem from '../../../common/forms/FormItem';
import TextAreaInput from '../../../common/forms/input/TextAreaInput';
import ItinerarySearchForm from '../itinerary/ItinerarySearchForm';
import { INT_DATE_FORMAT } from '../../../../config/locale';
import { tzNormalizeDate, tzDiff } from '../../../../utils/date';

const MAX_MONTHS_IN_REPORT = 2;

const notesField = (
  <FormGroup row>
    <FormItem label="Notas">
      <Field
        name="notes"
        component={TextAreaInput}
        type="textarea"
        placeholder="Notas"
      />
    </FormItem>
  </FormGroup>
);

const NewItineraryCounterReport = ({
  breadcrumbs,
  creating,
  dispatchPostItineraryCounterReport,
}) => {
  const onSubmitToCreate = (formValues) => {
    const monthsInRange = tzDiff({
      startDate: formValues.fromDateString,
      endDate: formValues.toDateString,
      unit: 'months',
    });

    if (monthsInRange >= MAX_MONTHS_IN_REPORT) {
      toastr.error(
        'Error',
        `El rango de fechas no debe exceder los ${MAX_MONTHS_IN_REPORT} meses.`,
      );
      return;
    }

    const values = {
      sourceLocationId: formValues.sourceLocationId
        ? formValues.sourceLocationId.value
        : null,
      destinationLocationId: formValues.destinationLocationId
        ? formValues.destinationLocationId.value
        : null,
      fromDateString: tzNormalizeDate({
        date: formValues.fromDateString,
        format: INT_DATE_FORMAT,
      }),
      toDateString: tzNormalizeDate({
        date: formValues.toDateString,
        format: INT_DATE_FORMAT,
      }),
      directionType: formValues.directionType
        ? formValues.directionType.value
        : null,
      showNorteChico: formValues.showNorteChico || false,
      driverId: formValues.driver ? formValues.driver.value : null,
      cabinCrewId: formValues.cabinCrew ? formValues.cabinCrew.value : null,
      activeOnly: formValues.activeOnly || false,
      notes: formValues.notes || null,
    };
    if (formValues.serviceType) {
      const serviceTypeList = Array.isArray(formValues.serviceType)
        ? formValues.serviceType
        : [formValues.serviceType];
      if (serviceTypeList.length) {
        values.serviceTypeIds = serviceTypeList.map(
          (serviceType) => serviceType.value,
        );
      }
    }
    dispatchPostItineraryCounterReport(values);
  };

  const today = tzNormalizeDate();

  const content = (
    <ItinerarySearchForm
      onSubmit={onSubmitToCreate}
      initialValues={{
        activeOnly: true,
        fromDateString: today,
        toDateString: today,
      }}
      sourceLocationIsRequired={false}
      destinationLocationIsRequired={false}
      searchByDateRange
      filterServiceType
      multipleServiceTypes
      showDirectionType
      showNorteChicoField
      showDriverField
      showCabinCrewField
      showActiveOnlyField
      isClearable
      extraField={notesField}
      extraFiltersOpenByDefault
      submitButtonText={creating ? 'Guardando...' : 'Guardar'}
      submitButtonIcon="fa fa-save"
      submitButtonColor="primary"
      submitButtonOutline={false}
      submitButtonDisabled={creating}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Reporte de Itinerarios"
      content={content}
    />
  );
};

NewItineraryCounterReport.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  creating: PropTypes.bool,
  dispatchPostItineraryCounterReport: PropTypes.func.isRequired,
};

NewItineraryCounterReport.defaultProps = {
  creating: false,
};

const mapDispatchToProps = {
  dispatchPostItineraryCounterReport: postItineraryCounterReport,
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Reportes de Itinerarios',
      href: ITINERARY_COUNTER_REPORT_PATH,
    },
    {
      text: 'Nuevo',
      href: NEW_ITINERARY_COUNTER_REPORT_PATH,
    },
  ],
  creating: !ItineraryUnit.ItineraryCounterReport.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewItineraryCounterReport);
